<template>
  <settings-modal class="payment-swift-topup-cancel-modal">
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <data-group heading="Withhold fee">
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            id="amount"
            v-model="form.amount"
            type="number"
            label="Fee amount"
            placeholder="0.00"
            hint="Required field"
            persistent-hint
            :error-messages="getValidationErrorMessage('feeAmount')"
          />
        </v-flex>

        <v-flex xs2>
          <v-autocomplete
            id="currency"
            v-model="form.currency"
            :items="currencyOptions"
            item-text="name"
            item-value="value"
            label="Currency"
            placeholder=" "
            :disabled="true"
          />
        </v-flex>
      </v-layout>
    </data-group>

    <template slot="actions">
      <v-btn
        id="reject"
        color="primary"
        medium
        flat
        :disabled="loading || !canSubmit"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'
  import CurrencyRatesApi from '@/services/Api/CurrencyRatesApi'

  import CurrencyRate from '@/models/CurrencyRate'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import DataGroup from '@/components/ui/DataGroup'

  import form from '@/mixins/form'

  export default {
    name: 'PaymentSwiftTopUpCancelModal',
    components: {
      SettingsModal,
      ErrorAlert,
      DataGroup
    },
    mixins: [form],
    data () {
      return {
        form: {
          amount: null,
          currency: null
        },
        cancelSwiftTopUpByAccountantApiRequest: new ApiRequest(PaymentApi.cancelSwiftTopUpByAccountant),
        getRatesRequest: new ApiRequest(CurrencyRatesApi.getRates, CurrencyRate)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      defaultAmount () {
        return this.rates.filter(rate => rate.currency === this.paymentCurrency)[0]
      },
      requiredFields () {
        return ['amount', 'currency']
      },
      payment () {
        return this.modal.data.payment
      },
      paymentCurrency () {
        return this.payment.recipientCurrency
      },
      paymentAmount () {
        return this.payment.recipientAmount
      },
      heading () {
        return `Cancel payment ${this.payment.id}?`
      },
      loading () {
        return this.cancelSwiftTopUpByAccountantApiRequest.loading
      },
      error () {
        return this.cancelSwiftTopUpByAccountantApiRequest.error
      },
      canSubmit () {
        return this.isFormFilled
      },
      currencyOptions () {
        return [{
          name: this.paymentCurrency,
          value: this.paymentCurrency
        }]
      }
    },
    created () {
      this.setFieldValue('currency', this.paymentCurrency)
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.cancelSwiftTopUpByAccountantApiRequest
          .execute(this.payment.id, this.form.amount, this.form.currency)
          .then(this.cancelSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully canceled.' }
          })
        }, 100)
      }
    }
  }
  </script>

<style lang="scss">
  .payment-swift-topup-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
